export const AUTH = {
    v2: {
        loginRequest: '/api/v2/auth/login-request',
        verifyLoginOtp: '/api/v2/auth/verify-login-otp',
        verifySession: '/api/v2/auth/me',
        logout: '/api/v2/auth/logout',
        resendOtp: '/api/v2/auth/resend-otp',
        validateResetPasswordToken: '/api/v2/auth/validate-reset-password-token',
        verifyInitialLogin: '/api/v2/auth/verify-initial-login',
        setPassword: '/api/v2/auth/set-password',
        reInitDeployment: '/api/v2/auth/reinit-deployment'
    }
};

export const USER = {
    v1: {
        me: '/api/user/me',
        adminMe: '/api/user/admin-me'
    },
    v2: {
        fetchUser: '/api/v2/user',
        editUserInfo: '/api/v2/user/edit-info',
        updateTour: '/api/v2/user/update-tour'
    }
};

export const LEARNER = {
    v1: {
        inviteLearner: '/api/learner/invite-single',
        fetchLearners: '/api/learner'
    },
    v2: {
        fetchLearners: '/api/v2/learner',
        learnersCount: '/api/v2/learner/total-count',
        resendInvitation: '/api/v2/learner/resend-invitation',
        editLearner: '/api/v2/learner',
        editResults: '/api/v2/learner/edit-results',
        archiveFolders: '/api/v2/learner/archive-folders',
        archiveLearners: '/api/v2/learner/archive-list',
        deletedLearners: '/api/v2/learner/deleted-list',
        postArchiveLearners: '/api/v2/learner/archive',
        postUnarchiveLearners: '/api/v2/learner/unarchive',
        deleteLearners: '/api/v2/learner',
        restoreLearners: '/api/v2/learner/undelete',
        vfhResultsEmail: '/api/v2/learner/vfh-results-email'
    }
};

export const SETTINGS = {
    v1: {
        updateSettings: '/api/settings/update-organisation-info'
    },
    v2: {
        updateLogo: '/api/v2/settings/update-logo',
        updateSettings: '/api/v2/settings/update-organisation-info',
        fetchSettings: '/api/v2/settings',
        fetchSubscriptionList: '/api/v2/settings/subscription-list',
        fetchCurrentSubscription: '/api/v2/settings/current-subscription',
        updateNotification: '/api/v2/settings/update-notification',
        updateLearnerForm: '/api/v2/settings/update-learner-form',
        updateDefaultQuizLevel: '/api/v2/settings/update-default-quiz-level',
        updateAutoIncludeCourseReady: '/api/v2/settings/update-auto-include-course-ready',
        updateEmailTemplate: '/api/v2/settings/update-email-template',
        updateAxcelerate: '/api/v2/settings/update-axcelerate',
        testAxcelerate: '/api/v2/settings/test-axcelerate',
        updateApiEnabled: '/api/v2/settings/update-api-enabled',
        updateWisenetEnabled: '/api/v2/settings/update-wisenet-enabled',
        updateWebhooks: '/api/v2/settings/update-webhooks',
        updateDirectLinksStatus: '/api/v2/settings/update-direct-links-status'
    }
};

export const COURSES = {
    v1: {
        createCourse: '/api/course',
        updateCourse: '/api/course',
        copyCourse: '/api/course/copy',
        fetchCourses: '/api/course',
        fetchCourse: '/api/course/:id',
        deleteCourse: '/api/course'
    },
    v2: {
        fetchCourses: '/api/v2/course'
    }
};

export const UNITS = {
    v1: {
        fetchUnit: '/api/unit'
    }
};

export const REPORTS = {
    v2: {
        exportSummary: '/api/v2/reports/export-summary',
        exportAnswerReport: '/api/v2/reports/export-answer-report',
        exportProfileReport: '/api/v2/reports/export-profile-report',
        exportLearnersResults: '/api/v2/reports/export-learners-results',
        exportLearnerLLNReport: '/api/v2/reports/export-learners-lln-report',
        downloadLearnerReport: '/api/v2/reports/download-learner-report',
        exportAnalyticsReport: '/api/v2/reports/export-analytics-report'
    }
};

export const COURSE = {
    v2: {
        fetchCourses: '/api/course'
    }
};

export const RESOURCE = {
    v2: {
        fetchResources: '/api/v2/resource'
    }
};

export const ANALYTICS = {
    v2: {
        fetchCreatedCourses: '/api/v2/analytics/total-created-courses',
        fetchUnitsAnalysed: '/api/v2/analytics/total-units-analysed',
        fetchQuizzesCompleted: '/api/v2/analytics/completed-quizzes',
        fetchAvgQuizCompletionTime: '/api/v2/analytics/average-quiz-completion-time',
        fetchTotalLLNReportsGenerated: '/api/v2/analytics/total-lln-reports-generated',
        fetchLeanersAboveAcsfLevel3: '/api/v2/analytics/percent-learners-above-acsf-level-3',
        fetchTotalCompletedQuizzesByMonth: '/api/v2/analytics/total-completed-quizzes-by-month',
        fetchQuizUsed: '/api/v2/analytics/quiz-used',
        fetchAverageResults: '/api/v2/analytics/average-results',
        fetchTotalLLNReportsGeneratedByMonth: '/api/v2/analytics/total-lln-reports-generated-by-month',
        fetchDashboardLearnerAnalytics: '/api/v2/analytics/dashboard-learner-analytics'
    }
};

export const LOGS = {
    v2: {
        fetchLogs: '/api/v2/logs'
    }
};

export const NOTIFICATIONS = {
    v2: {
        fetchNotifications: '/api/v2/notifications',
        markRead: '/api/v2/notifications/mark-read'
    }
};

/**
 * Public IP API
 * 1. https://ipinfo.io/json
 * 2. http://ip-api.com/json
 * 3. https://api64.ipify.org?format=json (suggested best url for public ip)
 */
export const IP_INFO = {
    staticPublicIp: 'https://api64.ipify.org?format=json'
};

export const API_USERS = {
    v1: {
        fetchAll: '/api/v2/api-users',
        create: '/api/v2/api-users'
    }
};

export const SYNCHRONISATIONLOGS = {
    v2: {
        fetchLogs: '/api/v2/synchronisationlog'
    }
};
